import React, { useState, useEffect } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import Multiselect from "multiselect-react-dropdown";
import {
  getAllBusinesslist,
  getDepartment,
} from "../../../service/Department/DepartmentService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import {
  getAllModulelist,
  getAllRolelist,
  getNewUser,
} from "../../../service/AddUser/AddUserService";
import { getAllUserDetailslist } from "../../../service/AddUser/AddUserService";
import SpinnerComponent from "../../components/SpinnerComponent";
import { useTranslation } from "react-i18next";

const AddDepartment = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [departmentName, setDepartmentName] = useState("");
  const [shortName, setShortName] = useState("");
  const [identificationNumber, setIdentificationNumber] = useState("");
  const [accountKey, setAccountKey] = useState("");
  const [businessUnitNameId, setBusinessUnitNameId] = useState("");
  const [address, setAddress] = useState("");
  const [businessList, setAllBusinessList] = useState([]);
  const [department, setDepartment] = useState([]);
  const [search, setSearch] = useState("");

  const [myArrayUser, setMyArrayUser] = useState([]);
  const [userById, setUserById] = useState("");
  const [module, setModule] = useState([]);

  const [userList, setAllUserList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [stock, setStock] = useState(false);

  const onDepartmentName = (e) => {
    setDepartmentName(e.target.value);
  };
  const onShortName = (e) => {
    setShortName(e.target.value);
  };
  const onIdentificationNumber = (e) => {
    setIdentificationNumber(e.target.value);
  };
  const onAccountKey = (e) => {
    setAccountKey(e.target.value);
  };
  const onAddress = (e) => {
    setAddress(e.target.value);
  };
  const onBusinessUnitName = (e) => {
    setBusinessUnitNameId(e.target.value);
  };

  useEffect(() => {
    getBusinessUnitDataList();
  }, []);

  async function getBusinessUnitDataList() {
    setIsLoading(true);
    getAllBusinesslist(search, department).then(function (result) {
      const response = result.data;
      setAllBusinessList(response.data);
      setIsLoading(false);
    });
  }

  let businessUnitDropdown = <option>Loading...</option>;
  if (businessList && businessList.length > 0) {
    businessUnitDropdown = businessList.map((businessRow, index) => (
      <option value={businessRow.id}>{businessRow.name}</option>
    ));
  }

  useEffect(() => {
    getUserDataList();
  }, []);

  async function getUserDataList() {
    setIsLoading(true);
    getAllUserDetailslist(search, department).then(function (result) {
      const response = result.data;
      setAllUserList(response?.data?.employee);
      setIsLoading(false);
    });
  }

  const userDrop = userList?.map((userRow, index) => ({
    value: userRow?.id,
    label: userRow?.name,
  }));

  const onUser = (userId) => {
    setMyArrayUser([]);
    userId?.map((d) => {
      if (myArrayUser.includes(d?.value)) {
        setMyArrayUser(myArrayUser);
      } else {
        myArrayUser.push(d?.value);
        setMyArrayUser(myArrayUser);
      }
    });
    setUserById(userId);
  };

  console.log(myArrayUser, "myArrayUser");

  const onAddNow = () => {
    if (departmentName === "") {
      toast.error("Please type department name");
    } else if (shortName === "") {
      toast.error("Please type short name");
    } else if (identificationNumber === "") {
      toast.error("Please type department identification number");
    } else if (accountKey === "") {
      toast.error("Please type GL or account key");
    } else if (businessUnitNameId === "") {
      toast.error("Please select operator unit");
    } else if (address === "") {
      toast.error("Please type address");
    }

    //  else if (myArrayUser.length <= 0) {
    //     toast.error("Please select user")

    // }
    else {
      setIsLoading(true);
      getDepartment(
        departmentName,
        shortName,
        identificationNumber,
        accountKey,
        businessUnitNameId,
        address,
        myArrayUser,
        stock,
        (r) => {
          console.log(r, "response");
          if (r.success === true) {
            toast.success(r.message);
            navigate("/department");
          } else {
            toast.error(r.message);
          }
        }
      );
      setIsLoading(false);
    }
  };

  const handleStockChange = (e) => {
    setStock(e.target.id === "yes");
  };
  console.log("stock", stock);

  return (
    <div className="container-fluid">
      <div className="dbMain departMent">
        <Leftpanel breadcm={t("configuration")} />
        <div className="dbRight">
          <Header
            link="/department"
            breadcm={`${t("configuration")} > `}
            title={`${t("department")} > ${t("add_department")}`}
            description=""
          />
          {isLoading && <SpinnerComponent isLoading={isLoading} />}
          <div className="commonBase p-4">
            <form>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label htmlFor="Departmentname">{t("department_name")}</label>
                  <input
                    type="text"
                    id="Departmentname"
                    className="form-control"
                    placeholder={t("department_name")}
                    name="name"
                    onChange={onDepartmentName}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label htmlFor="Shortname">{t("short_name")}</label>
                  <input
                    type="text"
                    id="Shortname"
                    className="form-control"
                    placeholder={t("short_name")}
                    name="shortName"
                    onChange={onShortName}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label htmlFor="Departmentidentificationno.">
                    {t("department_identification_number")}
                  </label>
                  <input
                    type="text"
                    id="Departmentidentificationno."
                    className="form-control"
                    placeholder={t("department_identification_number")}
                    name="buIdentificationNumber"
                    onChange={onIdentificationNumber}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label htmlFor="GLorAccountingkey">
                    {t("gl_or_accounting_key")}
                  </label>
                  <input
                    type="text"
                    id="GLorAccountingkey"
                    className="form-control"
                    placeholder={t("gl_or_accounting_key")}
                    name="accountingKey"
                    onChange={onAccountKey}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label htmlFor="Businessunit">{t("business_unit")}</label>
                  <select
                    className="form-control"
                    id="Businessunit"
                    onChange={onBusinessUnitName}
                  >
                    <option selected hidden>
                      {t("select_business_unit")}
                    </option>
                    {businessUnitDropdown}
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label htmlFor="Address">{t("address")}</label>
                  <textarea
                    className="form-control"
                    id="Address"
                    placeholder={t("placeholder_address")}
                    onChange={onAddress}
                  ></textarea>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-3 multiSlct">
                  <label htmlFor="User">{t("user")}</label>
                  <Select
                    id="User"
                    placeholder={t("select_user")}
                    isMulti
                    options={userDrop}
                    value={userById}
                    onChange={onUser}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3 ">
                  <label htmlFor="User">{t("Stock")}</label>
                  <br></br>
                  <span>
                    <label htmlFor="Yes">
                      <input
                        type="radio"
                        name="supplierName"
                        id="yes"
                        className="m-1"
                        onChange={handleStockChange}
                      />
                      {t("Yes")}
                    </label>
                  </span>
                  &nbsp; &nbsp;
                  <span>
                    <label htmlFor="No">
                      <input
                        type="radio"
                        name="supplierName"
                        id="no"
                        className="m-1"
                        onChange={handleStockChange}
                      />
                      {t("No")}
                    </label>
                  </span>
                </div>
              </div>
              <button type="button" className="commonButton" onClick={onAddNow}>
                {t("add_now")}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDepartment;
